import axios from "axios";
import { appConfig } from "../../config";
import { imageHeaderAuth, refreshAuthLogic, jsonHeaderAuth } from "../fetchTools";


export const createRequest = async (payload) => {
    try {
        const { status, data } = await axios.post(`${appConfig.BASE_API}/request/insertNew`, payload, {
            ...imageHeaderAuth(),
            mode: 'cors'
        })

        return{ status, data }
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getEQByCode = async (code) => {
    try {
        const { status, data } = await axios.get(`${appConfig.BASE_API}/sticker/${code}`, {
            ...jsonHeaderAuth(),
            mode: 'cors'
        })

        return { status, data }
    } catch(err) {
        throw err
    }
}

export const getEQByCodeWithoutAuth = async (code) => {
    try {
        const { status, data } = await axios.get(`${appConfig.BASE_API}/sticker2/${code}`, {
            mode: 'cors'
        })

        return { status, data }
    } catch(err) {
        throw err
    }
}